export default __webpack_public_path__ + "static/media/IMG_045.ae7b1cde.jpg";